// noinspection JSUnresolvedVariable

import {setAsSelect2} from "../../helpers/inputs";
import createElement from "../../helpers/createElement";
import Axios from "axios";
import {handleAjaxSuccess} from "../../helpers/SwalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {setLoadingMessage} from "../../helpers/loading";

/**
 * @param {Element} selectElement
 */
function initStatusSelect(selectElement) {
	setAsSelect2(selectElement, {
		dropdownCssClass: 'component_todolist-status-select-dropdown',
		containerCssClass: 'component_todolist-status-select',
		templateResult: (status) => {
			if (!status.id) {
				// Skip non-options entries
				return status.text;
			}

			const bgColor = status.element.dataset.backgroundColor;
			const fontColor = status.element.dataset.fontColor;

			return $(createElement(`
				<div class="status-option" style="background-color: ${bgColor}; color: ${fontColor}">
					${status.text}
				</div>
			`))
		},
		templateSelection: (status) => {
			if (!status.id) {
				// Skip non-options entries
				return status.text;
			}

			const bgColor = status.element.dataset.backgroundColor;
			const fontColor = status.element.dataset.fontColor;

			return $(createElement(`
				<div class="selected-status" style="background-color: ${bgColor}; color: ${fontColor}">
					${status.text}
				</div>
			`))
		}
	});

	// Add wrapper class
	$(selectElement).data('select2').$container[0].classList.add('component_todolist-status-select-wrapper');

}

/**
 * Adds an event to an already initialized select so the item's status get updated on a
 * select2 change event the select must have the item's id and current status
 * value set as data elements.
 *
 * Must have route 'admin.todolists.update.status' defined
 *
 * @param {Element} select
 * @param onUpdate Optional callback on successful update
 * @param options Options sent with the update request
 */
function allowInlineUpdate(
	select,
	onUpdate = () => {
	},
	options = {},
) {
	// Init previous value
	select.dataset.previousValue = select.value;

	$(select).on('select2:select', () => {
		const previousValue = select.dataset.previousValue;
		const itemId = select.dataset.itemId;

		loading();
		setLoadingMessage('Changing Status');

		Axios
			.post(
				window['admin.todolists.update.status'].replace('_ITEM_', itemId),

				{
					status_id: select.value,
					options: options,
				}
			)
			.then(response => {
				handleAjaxSuccess(response, () => {
					// Update previous value to new value
					select.dataset.previousValue = select.value;

					// Call callback
					onUpdate(response.data);
				})
			})
			.catch(error => {
				handleAjaxError(error);

				// Set back original value
				$(select).val(previousValue);
				$(select).trigger('change');
			})
			.finally(stopLoading)
	})
}

export {initStatusSelect, allowInlineUpdate}
